import { render } from "./ed-organism-app-footer.vue?vue&type=template&id=bf4358f4"
import script from "./ed-organism-app-footer.vue?vue&type=script&lang=js"
export * from "./ed-organism-app-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__